/**
 * Copyright (C) 2018 Egylis,
 * Siège social, 46 rue René Clair, 75892 PARIS cedex 18 - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 07/12/18.
 *
 * Version : Generator 2.0.9
 */

/**
 * Meta Index
 */
export class MetaIndex {
    /**
     * Column Name
     */
    private readonly _name: string;

    /**
     * Constuctor
     * @param name name
     */
    constructor(name: string) {
        this._name = name;
    }

    /**
     * Getter.
     */
    public get name(): string {
        return this._name;
    }
}
